import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CoreAppComponent } from 'src/app/core/core-app.component.js';

@Component({
    template: '',
    selector: 'app-logout',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LogoutComponent extends CoreAppComponent implements OnInit {
	constructor() {
		super();
	}

	ngOnInit(): void {
		this.dependencies.authService.logout();
		this.dependencies.navigateService.loginPage().navigate();
	}
}
